export default __webpack_public_path__ + "static/media/age_0.1ce44fcd.jpeg";